import { handleActions } from "redux-actions";
import { COLLECTION_TIMELINE } from "constants/action-types";

interface ITimelineState {
    collectionTimeline: ICollectionFeedItem[];
    collectionTimelineFetching: boolean;
    collectionTimelineError: Error | string;
    collectionTimelineHasNextPage: boolean;
}

interface IActor {
    type: string;
    object: string;
    summary: string;
    name: string;
    id: string;
}

interface IUrl {
    type: string;
    href: string;
    href_lang: string;
    media_type: string;
    name: string;
}

interface ITarget {
    type: string;
    name: string;
    id: string;
}

interface IResult {
    type: string;
    name: string;
}

interface ILocation {
    type: string;
    name: string;
    longitude: string;
    latitude: string;
}

interface IObject {
    type: string;
    actor: IActor;
    name: string;
    content: string;
    url: IUrl;
    target: ITarget;
    location: ILocation;
    object: IObject[];
    id: string;
    summary: string;
}

interface IOrigin {
    type: string;
    name: string;
    id: string;
}

export interface ICollectionFeedItem {
    id: string;
    type: string;
    name: string;
    created_at: string;
    summary: string;
    summary_markdown?: string;
    url: IUrl;
    actor: IActor;
    actors: IActor[];
    target: ITarget;
    targets: ITarget[];
    result: IResult;
    object: IObject;
    objects: IObject[];
    origin: IOrigin;
    origins: IOrigin[];
    meta: { [key: string]: any };
}

interface ITimelineSuccessPayload {
    results: ICollectionFeedItem[];
    hasNextPage?: boolean;
}

interface ISuccessPayload {
    type: string;
    payload: ITimelineSuccessPayload;
}

interface IErrorPayload {
    type: string;
    [props: string]: any;
}

const timelineState: ITimelineState = {
    collectionTimeline: [],
    collectionTimelineFetching: false,
    collectionTimelineError: undefined,
    collectionTimelineHasNextPage: false,
};

export const timeline = handleActions<ITimelineState>(
    {
        [COLLECTION_TIMELINE.FETCH.START]: (state: ITimelineState): ITimelineState => {
            return {
                ...state,
                collectionTimelineFetching: true,
                collectionTimelineHasNextPage: false,
            };
        },
        [COLLECTION_TIMELINE.FETCH.SUCCESS]: (state: ITimelineState, { payload }: ISuccessPayload): ITimelineState => {
            return {
                ...state,
                collectionTimeline: payload.results,
                collectionTimelineHasNextPage: payload.hasNextPage,
                collectionTimelineFetching: false,
            };
        },
        [COLLECTION_TIMELINE.FETCH.ERROR]: (state: ITimelineState, { payload }: IErrorPayload): ITimelineState => {
            return {
                ...state,
                collectionTimeline: [],
                collectionTimelineFetching: false,
                collectionTimelineHasNextPage: false,
                collectionTimelineError: payload.error,
            };
        },
    } as any,
    timelineState
);
